2
<template>
  <v-card outlined>
    <div v-if="systemNotifications.length">
      <v-card-title
        class="subtitle-3 d-flex"
        style="word-break: normal; justify-content: space-evenly; flex-wrap: nowrap"
      >
        <v-btn class="text-capitalize" depressed elevation="8" fab dark @click="$emit('prev')">
          <v-icon size="20" v-text="icons.mdiArrowLeft"></v-icon>
        </v-btn>
        <span class="text-h4 pl-5 pr-5">{{ translations.step6Title[lang] }}</span>

        <v-btn
          class="text-capitalize"
          depressed
          :elevation="(canGoToNextStep && !this.loading && 8) || 0"
          dark
          fab
          :disabled="!canGoToNextStep || loading"
          @click="goToNextStep()"
        >
          <v-icon size="20" v-text="icons.mdiArrowRight"></v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="text--primary pt-5">
        <v-row>
          <v-col cols="12" sm="12" class="d-flex pa-0 justify-center align-items-center">
            <v-tabs
              v-model="selectedTab"
              bg-color="primary"
              class="d-flex justify-center align-items-center priority-tabs text-h3"
              align-tabs="center"
              active-class="priority-tab-active"
            >
              <v-tab href="#priority">{{ translations.prioritySendTitle[lang] }} </v-tab>
              <v-divider class="" vertical></v-divider>
              <v-tab href="#all"> {{ translations.allChannelSendTitle[lang] }}</v-tab>
              <v-divider
                v-if="newReward.points || newReward.gift_ids.length"
                class=""
                vertical
              ></v-divider>
              <v-tab v-if="newReward.points || newReward.gift_ids.length" href="#none" class="">
                {{ translations.noChannelTitle[lang] }}</v-tab
              >
            </v-tabs>
          </v-col>
          <v-col
            class="d-flex justify-center text-subtitle-1 pt-5 pb-11"
            style="position: relative"
          >
            <span
              style="position: absolute"
              :class="[selectedTab != 'priority' && 'invisible', 'transition-all']"
              >{{ translations.prioritySendDescription[lang] }}</span
            >
            <span
              style="position: absolute"
              :class="[selectedTab != 'all' && 'invisible', 'transition-all']"
              >{{ translations.allChannelSendDescription[lang] }}</span
            >
            <span
              style="position: absolute"
              :class="[selectedTab != 'none' && 'invisible', 'transition-all']"
              >{{ translations.noChannelDescription[lang] }}</span
            >
          </v-col>
          <v-col
            :class="[selectedTab == 'none' && 'invisible', 'transition-all']"
            cols="12"
            sm="12"
          >
            <v-col cols="12" sm="12" v-if="allChannels.length" class="d-flex justify-center">
              <v-checkbox
                v-model="newReward.override_user_notification_settings"
                color="secondary"
                class="mt-3 pt-0"
                hide-details="auto"
              >
                <template v-slot:label>
                  <h4 class="secondary--text">
                    {{ translations.overrideText[lang] }}
                  </h4>
                </template>
              </v-checkbox>
            </v-col>
            <v-col cols="12" sm="12" v-if="allChannels.length" class="d-flex justify-center">
              <div
                style="position: absolute; max-width: 650px; width: 100%; overflow: visible"
                class="d-flex flex-column transition-all"
                :class="!hasPriority && 'invisible'"
              >
                <div
                  class="mb-10 d-flex align-center transition-all"
                  v-for="(item, index) in allChannels"
                  :key="index"
                  style="height: 94px; width: 100%; overflow: visible"
                >
                  <v-card
                    :elevation="allChannels.filter((x) => x.active).length > index ? 6 : 0"
                    class="pa-4 d-flex justify-start align-center rounded-pill rounded-r-lg transition-all"
                    style="height: 100%; max-height: 70px"
                    :disabled="!item.active || index >= allChannels.filter((x) => x.active).length"
                    :color="
                      allChannels.filter((x) => x.active).length > index
                        ? `rgba(60, 179, 113, ${(item.active && '0.5') || '0.3'})`
                        : ''
                    "
                    :class="(!hasPriority && 'invisible wild-west' + index) || 'no-right-shadow'"
                  >
                    <span
                      class="font-weight-bold text-left text-h3"
                      :class="[
                        allChannels.filter((x) => x.active).length > index ? '' : 'invisible',
                      ]"
                      >{{ index + 1 }}</span
                    >
                  </v-card>
                  <div
                    class="d-flex justify-center transition-all"
                    :class="[
                      !hasPriority && 'invisible far-north' + index,
                      index + 1 < allChannels.length && item.active && allChannels[index + 1].active
                        ? ''
                        : 'invisible',
                    ]"
                    style="margin-top: 133px; margin-left: 35%"
                  >
                    <v-icon size="28" v-text="icons.mdiArrowDownBold"></v-icon>
                  </div>
                </div>
              </div>

              <Container
                @drop="onDrop"
                drag-handle-selector=".column-drag-handle"
                style="position: relative; width: 100%"
                :style="{
                  'max-width': (hasPriority && '600px') || '100%',
                  'min-width': (hasPriority && 'auto') || '650px',
                }"
                class="ml-4 d-flex drag-cont flex-column justify-center transition-all"
              >
                <Draggable
                  v-for="(channel, index) in allChannels"
                  :key="channel.system"
                  class="pl-0 transition-all"
                  style="overflow: visible"
                >
                  <v-skeleton-loader
                    v-if="channelLoading"
                    class="d-flex justify-center transition-all mw-100 campaign-actions conditions-loader mb-12"
                    :types="{ actions: 'button@1' }"
                    type="actions"
                  ></v-skeleton-loader>
                  <div
                    v-else
                    style="position: relative"
                    :style="{
                      'min-width': (hasPriority && '386px') || 'auto',
                    }"
                    class="ml-4 d-flex justify-center"
                  >
                    <v-col
                      style="cursor: pointer"
                      class="draggable-item rounded-pill mb-10 pl-0"
                      cols="12"
                      sm="12"
                    >
                      <v-hover v-slot="{ hover }">
                        <v-card
                          style="max-height: 70px; max-width: 600px"
                          :style="{
                            'min-width': (hasPriority && '350px') || '180px',
                            'max-width': (hasPriority && '600px') || '350px',
                          }"
                          :elevation="((hover && 4) || 0) + ((channel.active && 4) || 0)"
                          class="mx-auto pl-2 ml-4 d-flex flex-row align-center rounded-pill transition-all"
                          :class="[
                            channel.active && hasPriority && 'rounded-l-lg',
                            !hasPriority && 'ml-0 no-priority-card no-priority-card' + index,
                            (hasPriority &&
                              (channel.valid
                                ? 'background-fill-transition-valid'
                                : (channel.valid === false && 'background-fill-transition-error') ||
                                  'background-fill-transition')) ||
                              (channel.active &&
                                ((channel.valid === false && 'background-fill-error') ||
                                  (channel.valid && 'background-fill-valid') ||
                                  '')),
                            hasPriority &&
                              (channel.active && allChannels.filter((x) => x.active).length > index
                                ? `background-fill-left no-left-shadow`
                                : 'background-empty'),
                          ]"
                        >
                          <v-tooltip color="secondary" top>
                            <template v-slot:activator="{ on }">
                              <v-btn
                                v-show="hasPriority"
                                color="secondary"
                                icon
                                v-on="on"
                                class="transition-all"
                                :class="[!(hasPriority && channel.active) ? 'invisible' : '']"
                              >
                                <span
                                  class="column-drag-handle transition-all"
                                  style="
                                    float: left;
                                    cursor: pointer;
                                    padding: 10px 15px;
                                    font-size: 24px;
                                  "
                                  >&#x2630;</span
                                >
                              </v-btn>
                            </template>
                            <span class="font-weight-bold" v-text="translations.drag[lang]"></span>
                          </v-tooltip>
                          <div
                            class="pa-6 pl-2 d-flex flex-row justify-center align-items-center pr-0"
                            style="min-width: 100px; width: 66%"
                            @click.prevent="activateChannel(channel, index)"
                          >
                            <v-card
                              color="rgba(255,255,255,0)"
                              flat
                              class="d-flex flex-row align-center ml-0 pl-2 pr-2 transition-all"
                              :disabled="!channel.active"
                              :class="[(channel.active && ' font-weight-bold') || 'ml-16']"
                            >
                              <Icon
                                v-if="channel.system == 'viber'"
                                icon="simple-icons:viber"
                                color="secondary"
                                :style="{
                                  fontSize: '24px',
                                }"
                              />
                              <v-icon v-else v-text="channel.icon" color="secondary"></v-icon>
                              <span class="pa-2">{{ channel.name.toUpperCase() }}</span>
                            </v-card>
                          </div>

                          <span
                            class="column-drag-handle pa-4 pl-0 d-flex flex-row"
                            style="float: left; cursor: pointer; z-index: 10"
                          >
                            <v-tooltip v-if="channel.active" color="secondary" top>
                              <template v-slot:activator="{ on }">
                                <v-btn
                                  color="secondary"
                                  icon
                                  v-on="on"
                                  @click="
                                    channel.active = false;
                                    channel.valid = channel.valid || undefined;
                                  "
                                >
                                  <v-icon v-text="icons.mdiVolumeOff"></v-icon>
                                </v-btn>
                              </template>

                              <span
                                class="font-weight-bold"
                                v-text="translations.deactivate[lang]"
                              ></span> </v-tooltip
                            ><v-tooltip v-if="channel.active" color="secondary" top>
                              <template v-slot:activator="{ on }">
                                <v-btn
                                  color="secondary"
                                  icon
                                  v-on="on"
                                  @click="
                                    () => {
                                      modalChannel = channel;
                                      channelDialog = true;
                                      modalChannelIndex = index;
                                    }
                                  "
                                >
                                  <v-icon v-text="icons.mdiPencilOutline"></v-icon>
                                </v-btn>
                              </template>

                              <span
                                class="font-weight-bold"
                                v-text="translations.edit[lang]"
                              ></span>
                            </v-tooltip>
                          </span>
                        </v-card>
                      </v-hover>
                    </v-col>
                  </div>
                </Draggable>
              </Container>
            </v-col>
          </v-col>
        </v-row>
      </v-card-text>
    </div>
    <v-dialog v-model="channelDialog" :max-width="modalChannel.system == 'mail' ? 1600 : 500">
      <ChannelForm
        v-if="channelDialog"
        :channel="modalChannel"
        @cancel="cancelDialog"
        @rise="
          changeChannelPosition({
            removedIndex: modalChannelIndex,
            addedIndex: validChannels.length,
            payload: null,
          })
        "
      />
    </v-dialog>
  </v-card>
</template>

<script>
import {
  mdiArrowLeft,
  mdiArrowRight,
  mdiPencilOutline,
  mdiWindowClose,
  mdiVolumeOff,
  mdiArrowDownBold,
  mdiMenuUp,
  mdiMenuDown,
  mdiEmailOutline,
  mdiMessageReplyTextOutline,
  mdiMessageTextOutline,
  mdiBellOutline,
  mdiInformationVariant,
} from '@mdi/js';
import { mapMutations, mapState, mapActions } from 'vuex';
import debounce from 'lodash/debounce';
import moment from 'moment';
import translations from '@/utils/translations/loyaltyPanel/campaigns/newCampaign';
import { Container, Draggable } from 'vue-dndrop';
import ChannelForm from '@/components/loyaltyPanel/newReward/ChannelForm.vue';
import { Icon } from '@iconify/vue2';

export default {
  name: 'Step2',

  mixins: [translations],

  components: {
    Container,
    Draggable,
    ChannelForm,
    Icon,
  },

  data: () => ({
    icons: {
      mdiArrowLeft,
      mdiArrowRight,
      mdiPencilOutline,
      mdiArrowDownBold,
      mdiWindowClose,
      mdiVolumeOff,
      mdiMenuUp,
      mdiMenuDown,
      mdiEmailOutline,
      mdiMessageReplyTextOutline,
      mdiMessageTextOutline,
      mdiBellOutline,
      mdiInformationVariant,
    },
    hover: false,
    dates: [],
    validPriority: false,
    renderEl: true,
    allChannels: [
      {
        name: 'push',
        system: 'push',
        active: false,
        priority: 1,
        icon: mdiBellOutline,
        has_image: false,
        title: {
          en: '',
          el: '',
          it: '',
        },
        body: {
          en: '',
          el: '',
          it: '',
        },
      },
      {
        name: 'sms',
        system: 'sms',
        active: false,
        priority: 2,
        icon: mdiMessageTextOutline,
        body: {
          en: '',
          el: '',
          it: '',
        },
      },
      {
        name: 'email',
        system: 'mail',
        active: false,
        priority: 4,
        icon: mdiEmailOutline,
        has_image: false,
        subject: '',
        body: '',
      },
      {
        name: 'viber',
        system: 'viber',
        active: false,
        priority: 3,
        icon: mdiEmailOutline,
        has_image: false,
        body: {
          en: '',
          el: '',
          it: '',
        },
        validity_period: '60',
        promotional: true,
        button: {
          en: '',
          el: '',
          it: '',
        },
        button_url: '',
        fallback: false,
        sms: {
          en: '',
          el: '',
          it: '',
        },
      },
    ],
    channelDialog: false,
    testDialog: false,
    channelLoading: false,
    smsMobile: '',
    modalChannel: {},
    modalChannelIndex: null,
    channelsDefaults: {
      sms: {
        en: '',
        el: '',
        it: '',
      },
      push: {
        body: {
          en: '',
          el: '',
          it: '',
        },
        title: {
          en: '',
          el: '',
          it: '',
        },
        link: '',
        has_image: false,
      },
      mail: {
        body: {
          en: '',
          el: '',
          it: '',
        },
        title: {
          en: '',
          el: '',
          it: '',
        },
        link: '',
        has_image: false,
      },
      viber: {
        title: {
          en: '',
          el: '',
          it: '',
        },
        body: {
          en: '',
          el: '',
          it: '',
        },
        validity_period: '60',
        promotional: true,
        button: {
          en: '',
          el: '',
          it: '',
        },
        button_url: '',
        fallback: false,
        sms: {
          en: '',
          el: '',
          it: '',
        },
      },
    },
    selectedTab: 'priority',
  }),

  computed: {
    ...mapState('loyaltyPanel/campaigns/rewards', [
      'systemNotifications',
      'canGoToNextStep',
      'step',
    ]),

    ...mapState(['loading']),

    lang() {
      return this.$route.params.lang;
    },

    newReward: {
      get() {
        return this.$store.state.loyaltyPanel.campaigns.rewards.newReward;
      },
      set(val) {
        this.setNewCampaign(val);
      },
    },

    activeChannels() {
      return this.allChannels.filter((x) => x.active) || [];
    },

    validChannels() {
      return this.activeChannels.filter((x) => x.valid) || [];
    },
    hasPriority() {
      return this.selectedTab == 'priority';
    },
  },

  methods: {
    ...mapMutations('loyaltyPanel/campaigns/rewards', ['setCanGoToNextStep']),
    ...mapActions('loyaltyPanel/campaigns/newCampaign', ['getNotificationVariables']),

    changeChannelPosition(dropResult) {
      if (
        !this.validChannels
          .map((e) => e.system)
          .includes(this.allChannels[dropResult.removedIndex].system)
      ) {
        this.allChannels = this.applyDrag(this.allChannels, dropResult);
      }
    },

    applyDrag(arr, dragResult) {
      const { removedIndex, addedIndex, payload } = dragResult;

      if (removedIndex === null && addedIndex === null) return arr;

      this.allChannels[removedIndex].priority = addedIndex + 1;

      const result = [...arr];
      let itemToAdd = payload;
      if (removedIndex !== null) {
        itemToAdd = itemToAdd || result.splice(removedIndex, 1)[0];
      }
      if (addedIndex !== null) {
        result.splice(addedIndex, 0, itemToAdd);
      }
      return result;
    },

    ...mapActions('loyaltyPanel/campaigns/rewards', ['getSystemNotifications']),

    onDrop(dropResult) {
      this.allChannels = this.applyDrag(this.allChannels, dropResult);
    },
    // dragChange(args) {
    //     console.log(args);
    // },
    // dragStart(args) {
    //     console.log(args.originalEvent.srcElement);
    // },
    activateChannel(c, i) {
      this.modalChannel = c;
      this.modalChannelIndex = i;
      this.channelDialog = !c.valid;
      c.active = true;
    },
    closeChannel(c, i) {
      c.active = false;
    },
    cancelDialog() {
      this.channelDialog = false;
      // this.modalChannel.active = false;
    },

    goToNextStep() {
      this.newReward.notifier_type = this.selectedTab;
      if (this.selectedTab == 'none') {
        this.newReward.notifier_type = undefined;
        this.allChannels.forEach((e) => {
          e.active = false;
        });
      }
      this.$nextTick(() => {
        this.$emit('next');
      });
    },

    checkStepValidity() {
      this.setCanGoToNextStep(false);
      if (
        (this.newReward.system_notification_ids.length && this.validChannels.length) ||
        this.selectedTab == 'none'
      ) {
        this.setCanGoToNextStep(true);
      }
    },
  },

  async mounted() {
    this.getNotificationVariables();
    this.channelLoading = true;
    if (this.newReward.reward_id) {
      this.selectedTab = this.newReward.notifier_type || 'none';
    }
    await this.getSystemNotifications();
    if (this.newReward.reward_id) {
      let priorities = this.newReward.system_notification_ids.map((e) => {
        return (
          (this.systemNotifications.find((x) => x.system_notification_id == e) || {}).channel || ''
        );
      });
      let priorityArray = [];
      priorities.forEach((e) => {
        priorityArray.push(this.allChannels.find((x) => x.system == e));
      });
      this.allChannels = priorityArray.filter(Boolean);

      let sms = this.allChannels.find((x) => x.system == 'sms');
      let push = this.allChannels.find((x) => x.system == 'push');
      let email = this.allChannels.find((x) => x.system == 'mail');
      let viber = this.allChannels.find((x) => x.system == 'viber');

      if (sms) {
        sms.body = sms.body || { en: '', el: '', it: '' };
        sms.body.en = this.newReward.sms?.en || '';
        sms.body.el = this.newReward.sms?.el || '';
        sms.body.it = this.newReward.sms?.it || '';
        sms.active = Boolean(this.newReward.sms?.en);
        sms.valid = Boolean(this.newReward.sms?.en);
      }

      if (push) {
        push.body = push.body || { en: '', el: '', it: '' };
        push.title = push.title || { en: '', el: '', it: '' };
        push.body.en = this.newReward.push?.body?.en || '';
        push.body.el = this.newReward.push?.body?.el || '';
        push.body.it = this.newReward.push?.body?.it || '';
        push.title.en = this.newReward.push?.title?.en || '';
        push.title.el = this.newReward.push?.title?.el || '';
        push.title.it = this.newReward.push?.title?.it || '';
        push.image = this.newReward.push?.image || '';
        push.has_image = Boolean(push.image);
        push.link = this.newReward.push?.link || '';
        push.active = Boolean(this.newReward.push?.body?.en);
        push.valid = Boolean(this.newReward.push?.body?.en);
      }

      if (email) {
        email.body =
          typeof email.body === 'object' && email.body ? email.body : { en: '', el: '', it: '' };
        email.title = email.title || { en: '', el: '', it: '' };
        email.body.en = this.newReward.email?.body?.en || '';
        email.body.el = this.newReward.email?.body?.el || '';
        email.body.it = this.newReward.email?.body?.it || '';
        email.title.en = this.newReward.email?.title?.en || '';
        email.title.el = this.newReward.email?.title?.el || '';
        email.title.it = this.newReward.email?.title?.it || '';
        email.image = this.newReward.email?.image || '';
        email.has_image = Boolean(email.image);
        email.link = this.newReward.email?.link || '';
        email.active = Boolean(this.newReward.email?.body?.en);
        email.valid = Boolean(this.newReward.email?.body?.en);
      }

      if (viber) {
        viber.body = viber.body || { en: '', el: '', it: '' };
        viber.title = viber.title || { en: '', el: '', it: '' };
        viber.sms = viber.sms || { en: '', el: '', it: '' };
        viber.button = viber.button || { en: '', el: '', it: '' };
        viber.body.en = this.newReward.viber?.body?.en || '';
        viber.body.el = this.newReward.viber?.body?.el || '';
        viber.body.it = this.newReward.viber?.body?.it || '';
        viber.title.en = this.newReward.viber?.title?.en || '';
        viber.title.el = this.newReward.viber?.title?.el || '';
        viber.title.it = this.newReward.viber?.title?.it || '';
        viber.sms.en = this.newReward.viber?.sms?.en || '';
        viber.sms.el = this.newReward.viber?.sms?.el || '';
        viber.sms.it = this.newReward.viber?.sms?.it || '';
        viber.button.en = this.newReward.viber?.button?.en || '';
        viber.button.el = this.newReward.viber?.button?.el || '';
        viber.button.it = this.newReward.viber?.button?.it || '';
        viber.image = this.newReward.viber?.image || '';
        viber.has_image = Boolean(this.newReward.viber?.has_image);
        viber.button_url = this.newReward.viber?.button_url || '';
        viber.fallback = Boolean(this.newReward.viber?.fallback);
        viber.promotional = true;
        viber.validity_period = this.newReward.viber?.validity_period || '60';
        viber.active = Boolean(
          this.newReward.viber?.body?.en ||
            this.newReward.viber?.promotional ||
            this.newReward.viber?.image ||
            this.newReward.viber?.button_url
        );
        viber.valid = viber.active;
      }
    }
    this.newReward.notifier_type = this.selectedTab == 'none' ? null : this.selectedTab;

    this.checkStepValidity();
  },

  watch: {
    step: {
      immediate: true,
      handler(val) {
        if (val == 2) {
          this.checkStepValidity();
        }
      },
    },

    systemNotifications: {
      immediate: true,
      handler(val) {
        if (val && val.length) {
          this.allChannels = this.allChannels.filter((e) => val.find((x) => e.system == x.channel));
          this.channelLoading = false;
        }
      },
    },

    validChannels: {
      immediate: true,
      handler(val, oldVal) {
        if (!val || !val.length) {
          if (oldVal && oldVal.length) {
            this.newReward.system_notification_ids = [];
          }
          return;
        }
        this.validPriority = true;
        val.forEach((e, i) => {
          if (this.allChannels[i].system !== e.system) {
            this.validPriority = false;
          }
        });
        if (!this.hasPriority || this.validPriority) {
          this.newReward.system_notification_ids =
            val.map(
              (e) =>
                this.systemNotifications?.find((x) => x.channel == e.system)?.system_notification_id
            ) || [];
        } else {
          this.newReward.system_notification_ids = [];
        }
        this.checkStepValidity();
      },
      deep: true,
    },

    activeChannels: {
      immediate: true,
      handler(val) {
        val.forEach((e, i) => {
          if (
            (!this.hasPriority || this.validPriority) &&
            this.validChannels.find((x) => x.system == e.system)
          ) {
            let channel = {
              ...e,
              valid: undefined,
              icon: undefined,
              active: undefined,
              priority: undefined,
              system: undefined,
              name: undefined,
              image_file: undefined,
            };
            delete channel.image_file;
            // Keep existing image URL if channel image is empty (preserves uploaded image)
            if (!channel.image && this.newReward[e.system]?.image) {
              channel.image = this.newReward[e.system].image;
            }
            if (e.system == 'sms') {
              this.newReward.sms = channel.body;
            } else {
              this.$set(this.newReward, e.system, channel);
            }
          } else {
            this.newReward[e.system] = undefined;
          }
        });
        this.checkStepValidity();
      },
      deep: true,
    },
  },
};
</script>

<style>
.priority-tabs .v-slide-group__wrapper {
  border-radius: 9999px !important;
  box-shadow:
    0px 2px 4px -1px rgba(0, 0, 0, 0.2),
    0px 4px 5px 0px rgba(0, 0, 0, 0.14),
    0px 1px 10px 0px rgba(0, 0, 0, 0.12) !important;
}
.priority-tabs .v-tabs-slider-wrapper {
  /* display: none; */
  color: black !important;
  caret-color: black !important;
}
.no-messages .v-messages {
  display: none;
}
.hover-bold:hover {
  font-weight: 600;
  text-shadow: black 1px 0 10px;
}
</style>

<style scoped>
.no-priority-card {
  width: 25%;
}
.no-priority-card1 {
  margin-left: 33% !important;
  margin-top: -134px !important;
}
.no-priority-card2 {
  margin-left: 66% !important;
  margin-top: -198px !important;
}
.invisible {
  opacity: 0;
}
.no-right-shadow {
  clip-path: inset(-5px 0px -5px -5px);
}
.no-left-shadow {
  clip-path: inset(-5px -5px -5px 0px);
}
.wild-east {
  margin-left: 42222px;
}
.wild-west0 {
  margin-left: -2222px;
}
.wild-west1 {
  margin-left: -4222px;
}
.wild-west2 {
  margin-left: -6222px;
}
.far-north0 {
  margin-left: 200px !important;
  margin-top: -4222px !important;
}
.far-north1 {
  margin-left: 4222px !important;
  margin-top: -6222px !important;
}
.transition-all {
  transition:
    all 0.5s,
    width 2s,
    max-width 1s,
    min-width 1s,
    margin-left 2s,
    margin-top 2.5s,
    background-position 1.5s,
    opacity 2s,
    background-color 2s;
}
.transition-all * {
  transition:
    all 0.5s,
    width 2s,
    max-width 1s,
    min-width 1s,
    margin-left 2s,
    margin-top 2.5s,
    background-position 1.5s,
    opacity 2s,
    background-color 2s;
}
.background-fill-transition-valid {
  background: linear-gradient(to right, rgba(60, 179, 113, 0.5) 50%, white 50%);
  background-size: 201% 101%;
  background-position: right bottom;
}
.background-fill-transition-error {
  background: linear-gradient(to right, rgba(255, 46, 46, 0.75) 50%, white 50%);
  background-size: 201% 101%;
  background-position: left top;
}
.background-fill-transition {
  background: linear-gradient(to left, white 50%, white 50%);
  background-size: 201% 101%;
  background-position: right bottom;
}
.background-fill-left {
  background-position: left bottom;
}

.background-fill-valid {
  background: linear-gradient(to right, rgba(60, 179, 113, 0.5) 50%, rgba(60, 179, 113, 0.5) 50%);
  background-size: 201% 101%;
  background-position: right bottom;
}
.background-fill-error {
  background: linear-gradient(to right, rgba(255, 46, 46, 0.75) 50%, rgba(255, 46, 46, 0.75) 50%);
  background-size: 201% 101%;
  background-position: right bottom;
}

.background-empty {
  background: linear-gradient(to right, white 50%, white 50%);
  background-size: 201% 101%;
  background-position: right bottom;
}
.priority-tab-active {
  font-weight: 550;
  color: rgba(0, 0, 0, 0.9);
  /* background: rgba(60, 179, 113, 0.5); */
  background: primary;
  border-bottom: none;
  box-shadow:
    0px 2px 4px -1px rgba(0, 0, 0, 0.2),
    0px 4px 5px 0px rgba(0, 0, 0, 0.14),
    0px 1px 10px 0px rgba(0, 0, 0, 0.12) !important;
  /* background-size: 201% 101%;
    background-position: right bottom; */
}
.info-icon {
  font-size: 18px !important;
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 9999px;
  border: 0px solid black;
}
</style>
